export class UpdateQuoteMessage {
  buildTypeId: number
  cartridgeId?: number
  customerSuppliedParts: string
  partsDiscountPercentage: number
  receivedCustomerApproval: boolean
  sendForCustomerApproval: boolean
  servicesDiscountPercentage: number
  
  constructor(buildTypeId: number, cartridgeId: number|undefined, customerSuppliedParts: string, partsDiscountPercentage: number, receivedCustomerApproval: boolean, sendForCustomerApproval: boolean, servicesDiscountPercentage: number) {
    this.buildTypeId = buildTypeId
    this.cartridgeId = cartridgeId
    this.customerSuppliedParts = customerSuppliedParts
    this.partsDiscountPercentage = partsDiscountPercentage
    this.receivedCustomerApproval = receivedCustomerApproval
    this.sendForCustomerApproval = sendForCustomerApproval
    this.servicesDiscountPercentage = servicesDiscountPercentage
  }
}
